import React from "react";

const Parcelamento = ({ price, discountPrice = 0, discountPercentage = 0 }) => {
  const finalPrice = discountPrice > 0 ? discountPrice : price;
  const desconto = discountPrice > 0 ? discountPercentage : 0;

  const jurosMensal = 0.0219;
  const parcelas = 10;

  const valorParcela = (
    (finalPrice * jurosMensal * Math.pow(1 + jurosMensal, parcelas)) /
    (Math.pow(1 + jurosMensal, parcelas) - 1)
  ).toFixed(2);

  const totalComJuros = (valorParcela * parcelas).toFixed(2);

  return (
    <div className="max-w-md mx-auto p-6 ">
      <p className="text-gray-700 text-lg mb-2">
        <span className="ml-2 font-extrabold text-lg text-red-500">
          10x de R$ {valorParcela}
        </span>
        <span className="ml-2 text-sm text-gray-500 italic">
          (com juros de 2.19% a.m.)
        </span>
      </p>

      {desconto > 0 && (
        <p className="text-green-700 bg-green-100 inline-block px-3 py-1 rounded-full font-semibold text-sm">
          Desconto aplicado: {desconto}%
        </p>
      )}
    </div>
  );
};

export default Parcelamento;
